// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import router from './router.js'
import Vue from 'vue'
import store from './store/'
import VueAnalytics from 'vue-analytics'
import AppConfig from '@/app-config'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css'
import '../node_modules/bootstrap/dist/css/bootstrap.css'
import '../node_modules/animate.css/animate.min.css'
import '../node_modules/vue2-animate/dist/vue2-animate.min.css'

import App from './App.vue'

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
    id: AppConfig.googleAnalyticsId
});

// Sentry.io
/*Sentry.init({
    dsn: 'https://53a0fdc90799420e8ab15522415430a3@sentry.io/1824624',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
});*/

/* eslint-disable no-new */
window.app = new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {
        App
    }
})
